// 无效模块单独跳过，避免一份损坏配置中断整站的模块列表计算。
export function readPortalModuleStyle(module) {
  if (!module || !module.moduleStyleData) return {}
  try {
    const value = typeof module.moduleStyleData === 'string'
      ? JSON.parse(module.moduleStyleData) : module.moduleStyleData
    return value && typeof value === 'object' && !Array.isArray(value) ? value : null
  } catch (error) {
    return null
  }
}
